import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './ui/Section';
export function FAQSection() {
  const faqs = [{
    question: 'Is this sleep training?',
    answer: 'No. There is no "crying it out" or leaving your baby alone. This is a transfer protocol designed to help you move a sleeping baby from your arms to a safe sleep space without waking them up.'
  }, {
    question: 'Does it work with reflux or colic?',
    answer: 'Yes. The protocol includes specific modifications for babies with reflux who need to be held upright for longer periods before transfer.'
  }, {
    question: 'How is this different from free advice?',
    answer: 'Free advice gives you tips ("wait until deep sleep"). This gives you a sequenced protocol with exact timing, depth checks, and a decision ladder for when things go wrong.'
  }, {
    question: 'What age range is this for?',
    answer: 'This is specifically designed for the "fourth trimester" (0–12 weeks). It works best for newborns who struggle with bassinet transfers.'
  }, {
    question: "What if it doesn't work?",
    answer: "We offer a 3-night money-back guarantee. If you run the protocol for 3 nights and don't see progress, just email us for a full refund."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section data-id="element-49">
      <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#faf6f0] mb-12 text-center" data-id="element-50">
        Common Questions
      </h2>
      <div className="space-y-4 max-w-2xl mx-auto" data-id="element-51">
        {faqs.map((faq, index) => <div key={index} className="border border-[#b8a9c9]/20 rounded-lg bg-[#1a1a2e] overflow-hidden" data-id="element-52">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-[#ffffff]/5 transition-colors" data-id="element-53">
              <span className="font-medium text-[#f5f0e8] text-lg" data-id="element-54">
                {faq.question}
              </span>
              <motion.div animate={{
            rotate: openIndex === index ? 180 : 0
          }} transition={{
            duration: 0.2
          }} data-id="element-55">
                <ChevronDown className="text-[#c9a96e]" data-id="element-56" />
              </motion.div>
            </button>
            <AnimatePresence data-id="element-57">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} data-id="element-58">
                  <div className="px-6 pb-4 text-[#d4cfc5] leading-relaxed border-t border-[#b8a9c9]/10 pt-4" data-id="element-59">
                    {faq.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}